import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';

import {AuthService} from './auth.service';
import {RoleService} from './role.service';

/**
 * Blocks read-only Members from mutation / admin shell routes.
 * Sales Manager denial for prohibited mutations is enforced by CoreOpsAccessGuard
 * and OrganizationMutationGuard on those routes — not here — so Sales Managers
 * can still open organization detail/profile from the customer listing.
 */
@Injectable({
    providedIn: 'root'
})
export class MemberMutationGuardService implements CanActivate {
    constructor(
        private auth: AuthService,
        private router: Router,
        private roleService: RoleService,
    ) {
    }

    canActivate(): boolean {
        if (!this.auth.isAuthenticated()) {
            void this.router.navigate(['/login']);
            return false;
        }

        const userInfo = this.auth.getCurrentUserInfo();
        if (!this.roleService.isMember(userInfo?.role)) {
            return true;
        }

        this.router.navigate([this.roleService.getDefaultRoute(userInfo?.role)]);
        return false;
    }
}
